var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-modal',{ref:"Modal",attrs:{"large":"","title":"Observação","buttons":['cancel']}},[_c('span',[_vm._v(" "+_vm._s(_vm.model.pedidoExame.exame.observacao)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }